import { FlexRow, FuuzeButton, type Podcast, type PodcastEpisode } from '@fuuze/shared';
import { RiForward15Fill, RiReplay15Fill } from 'react-icons/ri';
import styled from 'styled-components';
import { useShallow } from 'zustand/react/shallow';
import { usePlayerStore } from '../../store/player.store';
import { PlayerPlayButton } from './player-play-button';
import { PlayerSpotlightsDrawer } from './player-spotlights-drawer';

type PlayerControlsProps = {
  playIconSize?: number;
  otherIconSize?: number;
  podcast: Podcast;
  episode: PodcastEpisode;
  disabled?: boolean;
  hideSpotlightDrawer?: boolean;
};

export function PlayerControls({
  playIconSize,
  otherIconSize,
  podcast,
  episode,
  disabled,
  hideSpotlightDrawer,
}: PlayerControlsProps) {
  const [forward, backward] = usePlayerStore(useShallow(state => [state.forward, state.backward]));

  return (
    <FlexRow style={{ justifyContent: 'center', alignItems: 'center', gap: 16 }}>
      <Button disabled={disabled} icon onClick={backward} scaleOnHover>
        <RiReplay15Fill size={otherIconSize || 24} />
      </Button>
      <PlayerPlayButton
        disabled={disabled}
        channel={podcast}
        iconSize={playIconSize}
        item={episode}
        style={{ padding: 0 }}
      />
      <Button disabled={disabled} icon onClick={forward} scaleOnHover>
        <RiForward15Fill size={otherIconSize || 24} />
      </Button>
      {!hideSpotlightDrawer && <PlayerSpotlightsDrawer itemId={episode._id} />}
    </FlexRow>
  );
}

const Button = styled(FuuzeButton)`
  padding: 0;
`;
